import {slideFromTo} from "../helpers";

class SideTabs {
	constructor(el) {
		this.el           = el
		this.isAnimating  = false
		this.tabItems     = this.el.querySelectorAll( '.side-tabs__tabs .side-tabs__tabs-item' )
		this.content      = this.el.querySelector( '.side-tabs__content' )
		this.contentItems = this.el.querySelectorAll( '.side-tabs__content .content__item' )

		Array.from( this.tabItems ).forEach(
			(tab) => {
            tab.addEventListener(
				'click',
				(e) => {
                    e.preventDefault()
					if ( ! tab.classList.contains( 'is-active' ) && ! this.isAnimating) {
						this.isAnimating = true
						const activeTab  = this.getActiveTab();
						const targetTab  = {
							tab: tab,
							content: Array.from( this.contentItems ).find( el => el.dataset.tabId === tab.dataset.tabId )
						};

						slideFromTo( this.content, activeTab.content.offsetHeight, targetTab.content.children[0].offsetHeight, 600 )
						activeTab.content.classList.remove( 'is-active' )
						activeTab.tab.classList.remove( 'is-active' )

						setTimeout(
							() => {
                            targetTab.tab.classList.add( 'is-active' )
									targetTab.content.classList.add( 'is-active' )
								},
                            300
                        )
								setTimeout(
									() => {
                                    this.isAnimating = false
										},
									600
								)
					}
					}
			)
			}
		)
	}

	getActiveTab() {
		return {
			tab: Array.from( this.tabItems ).find( el => el.classList.contains( 'is-active' ) ),
			content: Array.from( this.contentItems ).find( el => el.classList.contains( 'is-active' ) )
		}
	}
}

(() => {
	Array.from( document.querySelectorAll( '.side-tabs' ) ).forEach( item => new SideTabs( item ) )
})()
